export default function PHP_quotemeta() {
  return (
    <div>
      <h1>PHP_quotemeta</h1>
    </div>
  );
}
